import { createSlice } from '@reduxjs/toolkit'
import { AxiosError } from '@src/helpers/httpClient'

import * as actionTypes from '../constants/actionTypes'
import { semesterAll, semesterAllClear } from './actions'
import { defaultState, initialState } from './initialState'

export const SEMESTER = actionTypes.GLOBAL_STATE

const semesterSlice = createSlice({
  name: SEMESTER,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(semesterAll.pending, state => {
        state[actionTypes.SEMESTER_ALL].loading = true
      })
      .addCase(semesterAll.rejected, (state, action) => {
        state[actionTypes.SEMESTER_ALL].loading = false
        state[actionTypes.SEMESTER_ALL].error = action.payload as AxiosError
      })
      .addCase(semesterAll.fulfilled, (state, action) => {
        state[actionTypes.SEMESTER_ALL].loading = false
        state[actionTypes.SEMESTER_ALL].error = null
        state[actionTypes.SEMESTER_ALL].data = action.payload
      })

    builder.addCase(semesterAllClear, state => {
      state[actionTypes.SEMESTER_ALL] = defaultState()
    })
  },
})

export const { reducer: semesterReducer } = semesterSlice
